export default {
  FETCH_SETTING_REQUEST: "FETCH_SETTING_REQUEST",
  FETCH_SETTING_FAILED: "FETCH_SETTING_FAILED",
  FETCH_SETTING_SUCCESS: "FETCH_SETTING_SUCCESS",
  DELETE_SETTING_REQUEST: "DELETE_SETTING_REQUEST",
  DELETE_SETTING_FAILED: "DELETE_SETTING_FAILED",
  DELETE_SETTING_SUCCESS: "DELETE_SETTING_SUCCESS",
  UPDATE_SETTING_REQUEST: "UPDATE_SETTING_REQUEST",
  UPDATE_SETTING_FAILED: "UPDATE_SETTING_FAILED",
  UPDATE_SETTING_SUCCESS: "UPDATE_SETTING_SUCCESS",

  ADD_EMPLOYEE_REQUEST: "ADD_EMPLOYEE_REQUEST",
  ADD_EMPLOYEE_FAILED: "ADD_EMPLOYEE_FAILED",
  ADD_EMPLOYEE_SUCCESS: "ADD_EMPLOYEE_SUCCESS",
};
